var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNuxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 50,
    viewBox: "0 0 76 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6184 2.69813C31.5261 -0.899377 26.2955 -0.899377 24.2031 2.69813L1.40045 41.9055C-0.691837 45.5031 1.92351 50 6.1081 50H23.9091C22.1211 48.4373 21.4589 45.7339 22.812 43.4145L40.0818 13.8114L33.6184 2.69813Z",
    fill: "#80EEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0665 11.2984C49.7981 8.35496 54.1269 8.35496 55.8585 11.2984L74.7297 43.3771C76.4613 46.3205 74.2969 49.9999 70.8337 49.9999H33.0914C29.6283 49.9999 27.4638 46.3205 29.1954 43.3771L48.0665 11.2984Z",
    fill: "#00DC82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuxt);
export default __webpack_public_path__ + "static/media/nuxt.194bd241b758a5892fe6b89f7d0bc6cc.svg";
export { ForwardRef as ReactComponent };